import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'

export default async function (data) {
	const node = data.node;
	const title = node.title;
	const serial = data.num;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme, 'headline')

	return {
		"id": id,
		"elements": [
			{
				"type": "text",
				"id": "SqSo61_dbX",
				"width": 110.17323003575687,
				"height": 75.09375,
				"left": 190.57,
				"top": 228.96,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": `<p style=\"text-align: center;\"><span style=\"font-size: 55.1px;font-family: 思源黑体 CN Normal;font-weight: bold;text-shadow: 2.21px 2.21px 3.13px #000000;\">${serial}</span></p>`,
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "text",
				"id": "KOQklkMxgQ",
				"width": 363.8,
				"height": 68.984375,
				"left": 280.63,
				"top": 232.55,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": `<p style=\"text-align: center;\"><span style=\"font-size: 48.98px;font-family: 思源黑体 CN Normal;font-weight: bold;text-shadow: 2.21px 2.21px 3.13px #000000;\">${title}</span></p>`,
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "shape",
				"id": "c7et3ouqUD",
				"width": 105.17323003575689,
				"height": 97.378557806913,
				"left": 195.57,
				"top": 218.35290859654356,
				"viewBox": [
					200,
					200
				],
				"path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
				"fill": "none",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#000",
					"width": 4.75,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333333",
					"align": "top"
				},
				"flipH": false,
				"flipV": false,
				"shadow": {
					"h": 2.21,
					"v": 2.21,
					"blur": 4.17,
					"color": "#00000066"
				}
			}
		],
		background
	};

}